<header class="page_header">
  <div class="header_content">
    <div class="text_and_supporting_text">
      <div class="page_title">Credit Note</div>
    </div>
    <div class="action_btn">
      <button class="btn primary_button" (click)="addNewCreditNote()" *RequiresPermission="{permissionIds: [PermissionConstants.CREDIT_NOTE.CREATE]}">
        <app-svg-icon [path]="'assets/icons/plus_icon.svg'"></app-svg-icon>
        New
      </button>

    </div>
  </div>
</header>

<div class="search_bar_with_table" *RequiresPermission="{permissionIds: [PermissionConstants.CREDIT_NOTE.LIST]};fallback: true">
  <div class="content">
    <app-tos-table
      [showTableStats]="false"
      [filterConfig]="CreditNoteListingConfig.filterConfig"
      [searchBarConfig]="CreditNoteListingConfig.searchBarConfig"
      [tableMeta]="tableMeta"
      [tableMenuOptions]="menuOptions"
      [(dataListRequest)]="tableListRequest"
      [dataListResponse]="tableListData"
      [(selectedItems)]="selectedItems"
      (tosTableAction)="getTableList()"
      (tableMenuOptionSelected)="handleOptionSelected($event)"
    >
    </app-tos-table>
  </div>
</div>
